import React, {ChangeEvent} from 'react';

import {LetterGrade} from '../constants';
import {select} from '../sharedStyles';
import {getLabel} from '../utils/LetterGradeUtils';

type Props = Readonly<{
  inputID: string;
  options: ReadonlyArray<LetterGrade>;
  value: LetterGrade | null;
  onChange: (grade: LetterGrade | null) => void;
}>;
export default function LetterGradeSelector(props: Props) {
  return (
    <select
      className={select}
      id={props.inputID}
      value={String(props.value || '')}
      onChange={(evt: ChangeEvent<HTMLSelectElement>) => {
        const value = evt.target.value;
        props.onChange(
          value === '' ? null : LetterGrade[value as keyof typeof LetterGrade],
        );
      }}>
      <option value="" />
      {props.options.map(option => (
        <option key={option} value={option}>
          {getLabel(option)}
        </option>
      ))}
    </select>
  );
}
